import { t } from 'utilities/TranslationUtils';
import { useHistory } from 'react-router-dom';

const NotFoundPage = () => {
  const history = useHistory();

  return (
    <button
      onClick={() => {
        history.push('/');
      }}
      className='btn btn-link d-block color-danger font-30 mx-auto text-underline'
    >
      {t('error.occurred')}
    </button>
  );
};

export default NotFoundPage;
